/**
 * Check if user is using a mobile device.
 *
 * @returns {boolean}
 */
export const isUsingMobileDevice = () => {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
};
